import { render } from "./DataError.vue?vue&type=template&id=7cf99691"
import script from "./DataError.vue?vue&type=script&lang=js"
export * from "./DataError.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__